module.exports = __webpack_public_path__ + "img/Menu-Accounts.43ade8f8.svg";